import type { Props as CartProps } from "~/components/cart/Cart"
import DesktopHeader from "~/components/header/desktop"
import MobileHeader from "~/components/header/mobile"
import type { Contact, Link, Logo, NavItem } from "~/components/header/types"
import type { Props as SearchbarProps } from "~/components/search/Searchbar"

import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco"
interface MobileService {
    /**
     * @description Texto mostrado antes dos contatos
     * @format html
     */
    header?: string
    /**
     * @description Texto mostrado depois dos contatos
     * @format html
     */
    footer?: string
}
interface Menu {
    /**
     * @title Textos de atendimento
     */
    service?: MobileService
}
export interface Props {
    /** @title Contatos */
    contacts?: Contact[]
    links?: Link[]
    /**
     * @title Alerta Mobile
     * @description Texto de alerta que ficará aparente apenas em dispositivos móveis
     * @format html
     */
    mobileAlert?: string
    /** @description Configure o menu dos dispositivos móveis */
    menu?: Menu
    /** @title Barra de Pesquisa */
    searchbar?: SearchbarProps
    /**
     * @title Itens de Navegação
     * @description Itens utilizados nos menus desktop e mobile
     */
    navItems?: NavItem[] | null
    /**
     * @title Carrinho
     * @description Componente de carrinho
     */
    cart?: CartProps
    /** @title Logo */
    logo?: Logo
}
export type HeaderProps = SectionProps<typeof loader>
export type DesktopProps = Omit<HeaderProps, 'isMobile'>
export type MobileProps = Omit<HeaderProps, 'isMobile'>
export default function Header({ isMobile, ...props }: HeaderProps) {
    return isMobile ? <MobileHeader {...props} /> : <DesktopHeader {...props} />
}
export const loader = (props: Props, request: Request, ctx: FnContext) => {
    const isHome = new URL(request.url).pathname === '/'
    const isMobile = ctx.device !== 'desktop'
    return { ...props, isHome, isMobile }
}

export const LoadingFallback = (props: Partial<Props>) => {
    return (
        <>
            <div className='block md:hidden'>
                <MobileHeader {...(props as MobileProps)} />
            </div>
            <div className='hidden md:block'>
                <DesktopHeader {...(props as DesktopProps)} />
            </div>
        </>
    )
}
